import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import HistoricalSplitView from '../HistoricalSplitView';

const HistoricalListingsPage = () => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const response = await fetch('/geocoded.json');
        if (!response.ok) throw new Error('Failed to load listings');
        const data = await response.json();
        
        // Transform the data to match the expected format
        const formattedListings = data.map(item => ({
          ...item.raw,
          Latitude: item.lat,
          Longitude: item.lon,
          // Ensure required fields have default values
          'Property Type': item.raw['Property Type'] || 'Unknown',
          'Close Price': item.raw['Close Price'] || '0',
          'Close Date': item.raw['Close Date'] || '',
          'Property Address': item.raw['Property Address'] || 'Address not available',
          'Neighborhood': item.raw['Neighborhood'] || 'N/A',
          'City': item.raw['City'] || 'N/A'
        }));
        
        setListings(formattedListings);
        setLoading(false);
      } catch (err) {
        console.error('Error loading listings:', err);
        setError('Failed to load listings. Please try again later.');
        setLoading(false);
      }
    };

    fetchListings();
  }, []);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#f8f9fa'
      }}>
        <div>Loading historical listings...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#f8f9fa',
        color: '#dc3545',
        padding: '20px',
        textAlign: 'center'
      }}>
        {error}
      </div>
    );
  }

  return (
    <div className="historical-listings-page" style={{ height: '100vh', width: '100%' }}>
      <HistoricalSplitView listings={listings} />
    </div>
  );
};

export default HistoricalListingsPage;
